import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useState } from "react";
import BModal from "react-bootstrap/Modal";

const QuestionPrompt = ({ show, onHide, modalData }) => {
  const [text, setText] = useState("");
  const [textTouched, setTextTouched] = useState(false);
  const [isTextValid, setIsTextValid] = useState(true);

  useEffect(() => {
    setText(modalData?.answer || "");
    setTextTouched(false);
    setIsTextValid(true);
  }, [modalData]);

  const handleSave = () => {
      const trimmed = text.trim();
      if (!trimmed) {
        setIsTextValid(false);
        setTextTouched(true);
        return;
      }
      modalData.onAnswerSaved(modalData.questionId, trimmed);
      onHide();
  };


  return (
    <BModal
      className="customer-modal-without-header-footer"
      centered
      show={show}
      onHide={onHide}
    >
      <BModal.Header closeButton>
        <p style={{ fontSize: "large", fontWeight: 600 }}>
          {modalData.heading}
        </p>
      </BModal.Header>

      <div style={{ position: "relative" }}>
        <textarea
          value={text}
          placeholder={modalData.placeholder}
          onChange={(e) => {
            setText(e.target.value);
            setTextTouched(true);
            setIsTextValid(!/^\s*$/.test(e.target.value));
          }}
          maxLength={200}
          style={{
            height: "300px",
            padding: "1rem",
            width: "100%",
            borderRadius: "10px",
            border: `2px solid ${
              textTouched && !isTextValid ? "red" : "#cbcbcb"
            }`,
          }}
        />
        <p style={{ position: "absolute", right: "1rem", bottom: "1rem" }}>
          {text.length}/200
        </p>
      </div>

      {textTouched && !isTextValid && (
        <p className="text-danger">Please provide some input to save</p>
      )}

      <div
        style={{
          marginTop: "2rem",
          display: "flex",
          gap: "1rem",
          justifyContent: "center",
        }}
      >
        <button
          className="global-cancel-button"
          onClick={() => {
            onHide();
            setText("");
            setTextTouched(false);
          }}
        >
          Cancel
        </button>
        <button className="global-save-button" onClick={handleSave}>
          Save
        </button>
      </div>
    </BModal>
  );
};
export default QuestionPrompt;
